module.exports = __webpack_public_path__ + "static/media/iron.42b8e9d3.svg";